import { render, staticRenderFns } from "./SectionTicketFiles.vue?vue&type=template&id=79560d58&scoped=true&"
import script from "./SectionTicketFiles.vue?vue&type=script&lang=js&"
export * from "./SectionTicketFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79560d58",
  null
  
)

export default component.exports